// extracted by mini-css-extract-plugin
export default {"icon":"ServingSizeIcon-module__icon__ZPBQK","additive":"ServingSizeIcon-module__additive__MtMo4","dot":"ServingSizeIcon-module__dot__PzXJ5"};